import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {AdicionalComparacaoIfoodVM, ResolucaoAdicionalIfoodVM, SnapshotOpcaoCanalVendaVM, SnapshotGrupoCanalVendaVM} from './canais-venda.models';

@Component({
  selector: 'app-resolucao-adicional-ifood',
  templateUrl: './resolucao-adicional-ifood.component.html',
  styleUrls: ['./resolucao-adicional-ifood.component.scss']
})
export class ResolucaoAdicionalIfoodComponent implements OnChanges {
  @Input() dados: AdicionalComparacaoIfoodVM;
  @Input() desabilitado = false;
  @Output() escolher = new EventEmitter<ResolucaoAdicionalIfoodVM | null>();
  @Output() revisar = new EventEmitter<void>();
  acao = '';
  candidatoId = '';
  gruposDesassociarIds: string[] = [];
  opcoes: {[id: number]: string} = {};
  imagensComErro = new Set<string>();

  ngOnChanges(changes: SimpleChanges): void {
    if(!changes.dados || !this.dados) return;
    this.acao = !this.dados.local.idExterno && !this.dados.candidatos.length && this.podeCriar ? 'NOVO' : '';
    this.candidatoId = this.vinculoNaoEncontrado ? '' : this.dados.local.idExterno || this.dados.candidatos[0]?.grupo.idExterno || '';
    this.gruposDesassociarIds = [];
    this.troqueCandidato(false);
  }

  get candidato() { return this.dados.candidatos.find(it => it.grupo.idExterno === this.candidatoId); }

  get vinculoNaoEncontrado(): boolean {
    return !!this.dados.local.idExterno && !this.dados.candidatos.some(it => it.grupo.idExterno === this.dados.local.idExterno);
  }

  get podeCriar(): boolean {
    return !!this.dados.permiteSubstituirVinculo || (!this.dados.local.idExterno && !this.dados.local.opcoes.some(it => it.idExterno));
  }

  get salvo() { return this.dados.candidatos.find(it => it.grupo.idExterno === this.dados.local.idExterno); }

  get candidatosDisponiveis(): AdicionalComparacaoIfoodVM['candidatos'] {
    return this.dados.permiteSubstituirVinculo ? this.dados.candidatos.filter(it =>
      this.dados.gruposSubstituiveis?.some(grupo => grupo.idExterno === it.grupo.idExterno)) : this.dados.candidatos;
  }

  get podeUsarOutro(): boolean { return this.candidatosDisponiveis.length > 0; }

  get gruposAtuais(): SnapshotGrupoCanalVendaVM[] { return this.dados.gruposAtuais || this.dados.gruposSubstituiveis || []; }

  get nomeGrupoEscolhido(): string { return this.acao === 'NOVO' ? this.dados.local.nome : this.candidato?.grupo.nome || 'Selecione um grupo'; }

  get grupoVaiEntrar(): boolean { return this.acao === 'NOVO' || !this.gruposAtuais.some(it => it.idExterno === this.candidatoId); }

  get nomesGruposMantidos(): string {
    return this.gruposAtuais.filter(it => !this.gruposDesassociarIds.includes(it.idExterno)).map(it => it.nome).join('; ') || 'Nenhum grupo atual';
  }

  get nomesGruposDesassociados(): string {
    return this.gruposAtuais.filter(it => this.gruposDesassociarIds.includes(it.idExterno)).map(it => it.nome).join('; ') || 'Nenhum';
  }

  podeDesassociar(grupo: SnapshotGrupoCanalVendaVM): boolean {
    return !!this.dados.gruposSubstituiveis?.some(it => it.idExterno === grupo.idExterno) &&
      (this.acao === 'NOVO' || grupo.idExterno !== this.candidatoId);
  }

  altereDesassociacao(grupo: SnapshotGrupoCanalVendaVM, desassociar: boolean): void {
    if(this.desabilitado || !this.acao || !this.podeDesassociar(grupo)) return;
    this.gruposDesassociarIds = this.gruposDesassociarIds.filter(id => id !== grupo.idExterno);
    if(desassociar) this.gruposDesassociarIds.push(grupo.idExterno);
    this.emita();
  }

  get quantidadeNovas(): number { return this.acao === 'NOVO' ? this.dados.local.opcoes.length : Object.values(this.opcoes).filter(it => it === 'NOVO').length; }

  get quantidadeVinculadas(): number { return Object.values(this.opcoes).filter(it => it && !['NOVO', 'IGNORAR'].includes(it)).length; }

  get quantidadeIgnoradas(): number { return Object.values(this.opcoes).filter(it => it === 'IGNORAR').length; }

  troqueAcao(): void {
    if(this.acao === 'REASSOCIAR') this.candidatoId = this.dados.local.idExterno;
    else if(this.acao === 'VINCULAR') {
      const associados = this.candidatosDisponiveis.filter(it => this.gruposAtuais.some(grupo => grupo.idExterno === it.grupo.idExterno));
      if(associados.length === 1) this.candidatoId = associados[0].grupo.idExterno;
      else if(!this.candidatoId || this.candidatoId === this.dados.local.idExterno)
        this.candidatoId = this.candidatosDisponiveis.find(it => it.grupo.idExterno !== this.dados.local.idExterno)?.grupo.idExterno || '';
    }
    this.troqueCandidato();
  }

  chaveOpcao(_indice: number, opcao: SnapshotOpcaoCanalVendaVM): number { return opcao.alvoLocalId; }

  selecioneCriacao(opcao: SnapshotOpcaoCanalVendaVM, criar: boolean): void {
    this.opcoes[opcao.alvoLocalId] = criar ? 'NOVO' : 'IGNORAR';
    this.emita();
  }

  vinculoOpcaoNaoEncontrado(opcao: SnapshotOpcaoCanalVendaVM): boolean {
    return !!opcao.idExterno && !this.candidato?.grupo.opcoes.some(it => it.idExterno === opcao.idExterno);
  }

  troqueCandidato(interagiu = true): void {
    this.gruposDesassociarIds = [];
    this.opcoes = {};
    for(const opcao of this.dados.local.opcoes) {
      if(opcao.idExterno && this.candidato?.grupo.opcoes.some(it => it.idExterno === opcao.idExterno))
        this.opcoes[opcao.alvoLocalId] = opcao.idExterno;
      else if(this.acao === 'VINCULAR') {
        const iguais = this.candidato?.grupo.opcoes.filter(it => it.nome.trim().toLocaleLowerCase() === opcao.nome.trim().toLocaleLowerCase()) || [];
        if(iguais.length === 1 && !this.usada(iguais[0].idExterno, opcao.alvoLocalId)) this.opcoes[opcao.alvoLocalId] = iguais[0].idExterno;
        else if(this.dados.permiteSubstituirVinculo) this.opcoes[opcao.alvoLocalId] = 'IGNORAR';
      }
    }
    this.emita(interagiu);
  }

  emita(interagiu = true): void {
    if(interagiu) this.revisar.emit();
    const base = {grupoLocalId: this.dados.local.alvoLocalId,
      ...(this.gruposDesassociarIds.length ? {gruposDesassociarIds: [...this.gruposDesassociarIds]} : {})};
    if((this.acao === 'REASSOCIAR' && !this.salvo) || (this.acao === 'NOVO' && !this.podeCriar) ||
      (this.acao === 'VINCULAR' && !this.candidatosDisponiveis.some(it => it.grupo.idExterno === this.candidatoId))) {
      this.escolher.emit(null); return;
    }
    if(this.acao === 'NOVO') {this.escolher.emit({...base, acao: 'NOVO'}); return;}
    const selecionadas = Object.values(this.opcoes).filter(id => id && !['NOVO', 'IGNORAR'].includes(id));
    if(!['VINCULAR', 'REASSOCIAR'].includes(this.acao) || !this.candidato || new Set(selecionadas).size !== selecionadas.length ||
      this.dados.local.opcoes.some(opcao => !this.opcoes[opcao.alvoLocalId])) {
      this.escolher.emit(null); return;
    }
    this.escolher.emit({...base, acao: this.acao as 'VINCULAR' | 'REASSOCIAR', grupoExternoId: this.candidatoId,
      opcoes: this.dados.local.opcoes.map(opcao => this.opcoes[opcao.alvoLocalId] === 'NOVO'
        ? {opcaoLocalId: opcao.alvoLocalId, acao: 'NOVO'}
        : this.opcoes[opcao.alvoLocalId] === 'IGNORAR' ? {opcaoLocalId: opcao.alvoLocalId, acao: 'IGNORAR'}
        : {opcaoLocalId: opcao.alvoLocalId, acao: 'VINCULAR', opcaoExternaId: this.opcoes[opcao.alvoLocalId]})});
  }

  usada(id: string, localId: number): boolean {
    return this.dados.local.opcoes.some(it => it.alvoLocalId !== localId && this.opcoes[it.alvoLocalId] === id);
  }

  correspondente(local: SnapshotOpcaoCanalVendaVM): SnapshotOpcaoCanalVendaVM | undefined {
    return this.candidato?.grupo.opcoes.find(it => it.idExterno === this.opcoes[local.alvoLocalId]);
  }

  difere(local: SnapshotOpcaoCanalVendaVM): boolean {
    const remota = this.correspondente(local);
    return !!remota && ['nome', 'codigoPdv', 'preco', 'disponivel'].some(campo => local[campo] !== remota[campo]);
  }

  valorRemoto(campo: string): string {
    if(!this.candidato || this.candidato.naoInformados.includes(campo)) return 'Não informado';
    const valor = this.candidato.grupo[campo];
    return typeof valor === 'boolean' ? (valor ? 'Sim' : 'Não') : String(valor);
  }

  statusRemoto(opcao: SnapshotOpcaoCanalVendaVM): string {
    return this.candidato.naoInformados.includes('opcao:' + opcao.idExterno + ':disponivel')
      ? 'Não informado' : opcao.disponivel ? 'Disponível' : 'Indisponível';
  }
}
